// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3nP75","icon":"SortAdornment_icon__2fUFS","up":"SortAdornment_up__2dHuz","down":"SortAdornment_down__2GZ1n","active":"SortAdornment_active__2uQIj"};